import {RadioGroup, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {arrayOf, bool, func, string} from 'prop-types';

import {FONT_FAMILIES} from '../../../const';
import Button from '../../form/buttons/Button/Button';
import Radio from '../../form/Radio/Radio';
import BaseModal from '../../modal/BaseModal';

const ChooseDroppedLinesCategoryModal = ({onClose, onSubmit, open, categories, selectedCategory, onCategorySelect}) => {
  if (categories.length === 0) return null;

  return (
    <BaseModal canCloseOnBackdropClick={false} maxWidth="sm" title="Choix du SIG" onClose={onClose} open={open}>
      <Box px={1.5} py={2}>
        <Typography fontFamily={FONT_FAMILIES.BODY}>Choisissez une valeur :</Typography>
        <RadioGroup
          row
          sx={{my: 2}}
          value={selectedCategory}
          onChange={e => onCategorySelect(e.target.value)}
          aria-labelledby="Choisir un utilisateur de l'application ou saisir un email"
          name="user-is-registered-on-app"
        >
          <Radio sx={{textStyle: 'none'}} value={categories[0]} label={categories[0]} checked={selectedCategory === categories[0]} />
          <Radio sx={{textStyle: 'none'}} value={categories[1]} label={categories[1]} checked={selectedCategory === categories[1]} />
        </RadioGroup>

        <Button disabled={!selectedCategory} onClick={onSubmit} variant="contained" color="secondary" fullWidth>
          Valider
        </Button>
      </Box>
    </BaseModal>
  );
};

ChooseDroppedLinesCategoryModal.propTypes = {
  open: bool.isRequired,
  selectedCategory: string.isRequired,
  onCategorySelect: func.isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  categories: arrayOf(string).isRequired
};

export default ChooseDroppedLinesCategoryModal;
